// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GridPanel__gridPanel__euZVo{display:flex}
`, "",{"version":3,"sources":["webpack://./src/js/apps/common/components/layout/GridPanel.scss"],"names":[],"mappings":"AAAA,6BACE,YAAa","sourcesContent":[".gridPanel {\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gridPanel": `GridPanel__gridPanel__euZVo`
};
export default ___CSS_LOADER_EXPORT___;
